import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useTenant from "../../../hooks/useTenant";
import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import FilterReset from "../../../components/FilterReset";
import { searchPayload, convertedValue, formatDate } from "../../../utils/common";
import ReactHookFormSelect from "../../../components/ReactHookFormSelect";
import CustomTextField from "../../../components/CustomTextField";
import { useDialog } from "../../../contexts/DialogContext";
import usePlan from "../../../hooks/usePlan";
import CustomDatePicker from "../../../components/CustomDatePicker";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const walletTypeOptions = [
  {
    label: "Recharge",
    value: "RC",
  },
  {
    label: "Deposit",
    value: "DE",
  },
  {
    label: "Static Ip",
    value: "SI",
  },
  {
    label: "Wrong Renewal",
    value: "WR",
  },
  {
    label: "Material Adjustment",
    value: "MA",
  },
  {
    label: "Double Renewal",
    value: "DR",
  },
  {
    label: "Online Renewal By Customer",
    value: "ORC",
  },
  {
    label: "Voice Recharge",
    value: "VR",
  },
  {
    label: "Advance Payment",
    value: "AP",
  },
  {
    label: "Auto Deposit",
    value: "AD",
  },
  {
    label: "Online Renewal Franchise",
    value: "ORT",
  },
  {
    label: "Amount Deposit from mso share",
    value: "ADF",
  },
];

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const today = formatDate(new Date());

  const initialValues = {
    createdAtStr: `${today} 00:00:00,${today} 23:59:59`,
    createdAt: [new Date(), new Date()],
    tenantName: {},
    walletType: {},
  };

  const { fields, payload, setPayload, setFilterResetFunc, filterFormData, setFilterFormData } =
    props;

  const { autoSearchTenant, tenantAutoSearchResults, isLoadingAutoSearch } = useTenant();

  const [tenantPayload, setTenantPayload] = useState(currentPayload);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [defaultTenant, setDefaultTenant] = useState({});
  const [defaultWalletType, setDefaultWalletType] = useState({});

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: filterFormData || initialValues,
  });

  console.log(initialValues, "initialValues");

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => () => reset(initialValues));
  }, [reset]);

  const onSubmit = async (data) => {
    try {
      setFilterFormData(data);
      let filters = [];

      if (data.tenantName != null && Object.keys(data.tenantName).length != 0) {
        filters.push({
          fieldName: "tenantId",
          fieldValue: convertedValue(data.tenantName, "value").join(","),
          op: "eq",
          dataType: "int",
          condition: "and",
          isJoin: true,
        });
      }
      if (data.walletType != null && Object.keys(data.walletType).length != 0) {
        filters.push({
          fieldName: "walletType",
          fieldValue: convertedValue(data.walletType, "value").join(","),
          op: "eq",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.createdAt != "" && data.createdAt != null) {
        console.log(data.createdAtStr, "data.createdAtStr");
        filters.push({
          fieldName: "createdAt",
          fieldValue: data.createdAtStr,
          op: "btn",
          dataType: "date",
          condition: "and",
          isJoin: false,
        });
      }

      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.error(err, "errerrerrerr");
    }
  };

  const fetchTenant = async () => {
    await autoSearchTenant(tenantPayload);
  };
  useEffect(() => {
    fetchTenant();
  }, [tenantPayload]);

  useEffect(() => {
    console.log(tenantAutoSearchResults, "tenantAutoSearchResults");
    if (tenantAutoSearchResults.data.length !== 0) {
      const results = [...tenantOptions, ...tenantAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setTenantOptions(filteredResults);
    }
  }, [tenantAutoSearchResults]);

  const searchFranchiseInputChange = (data) => {
    console.log(data, "searchInputChange");
    let filters = [];
    filters.push({
      fieldName: "tenantName",
      fieldValue: data,
      op: "like",
      dataType: "string",
      condition: "and",
      isJoin: false,
    });
    setTenantPayload({
      ...tenantPayload,
      filters: filters,
      pagination: {
        pageNumber: 1,
        pageSize: 100,
      },
    });
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} pt={8}>
            <Grid item md={6} sm={6} xs={8}>
              <SearchableAutoComplete
                control={control}
                data={tenantOptions}
                label="Franchise Name"
                payload={tenantPayload}
                setPayload={setTenantPayload}
                loading={isLoadingAutoSearch}
                name="tenantName"
                multiple={false}
                defaultValue={defaultTenant}
                hasNextPage={tenantAutoSearchResults.paging.hasNextPage}
                searchInputChange={searchFranchiseInputChange}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={8}>
              <SearchableAutoComplete
                control={control}
                data={walletTypeOptions}
                label="Wallet Type"
                payload={null}
                setPayload={null}
                loading={false}
                name="walletType"
                multiple={false}
                defaultValue={defaultWalletType}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} pt={8}>
            <Grid item md={6} sm={8} xs={12}>
              <CustomDatePicker
                name="createdAt"
                nameTemp="createdAtStr"
                label="Deposit Date"
                range={true}
                control={control}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={() => reset(initialValues)} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
